import actionCreatorFactory from 'typescript-fsa'

const actionCreator = actionCreatorFactory('Badges')

export interface ToggleBadgeModalPayload {
	show: boolean
	badgeId: number
	shouldBePushedToEarned: boolean
	earned: boolean
}
export const toggleBadgeModal = actionCreator<ToggleBadgeModalPayload>('TOGGLE_BADGE_MODAL')
